import React, { useEffect, useState } from "react"
import { Col, Row, Container } from "react-bootstrap"
import "./reset.css"

import { useVerifyEmailQuery } from "../../services/authServices"
import { useAppDispatch } from "../../app/hooks"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { emailVerifyToken } from "../../services/slices/profile"

const VerifyEmail = () => {
  const dispatch = useAppDispatch()
  const urlSearchParams = new URLSearchParams(window.location.search)
  const token = urlSearchParams.get("token")

  const navigate = useNavigate()
  const { data } = useVerifyEmailQuery({ token })

  // console.log("token", token)

  useEffect(() => {
    if (data?.message) {
      toast.success(data?.message)
    }
  }, [data])

  return (
    <>
      <div className="reset-form">
        <Container>
          <Row className="align-items-center">
            <Col md={12}>
              {data?.message && (
                <div className="form-content">
                  <h1>Email Verification Successful</h1>
                  <br /> Your email has been successfully verified. <br />
                  User session expired, Please log in again!
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default VerifyEmail
